import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const FIELD_SELECTOR = "input, textarea, select";

// Chrome ignores autocomplete="off" for fields it recognizes (name, email, address, search...)
// and still shows the saved-values dropdown. A nonsense value is the standard workaround.
function randomToken() {
  return `off-${Math.random().toString(36).slice(2)}`;
}

function disableAutocomplete(root) {
  root.querySelectorAll(FIELD_SELECTOR).forEach((el) => {
    if (el.dataset.acDisabled === "1") return;
    el.setAttribute("autocomplete", randomToken());
    el.dataset.acDisabled = "1";
  });
}

// Disables browser autofill/autocomplete everywhere except the login page.
export function useDisableAutocomplete() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/login") return undefined;

    disableAutocomplete(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches?.(FIELD_SELECTOR)) node.setAttribute("autocomplete", "off");
          disableAutocomplete(node);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [pathname]);
}
